import React from 'react';

function OptionButtons({ options, sendMessage }) {
  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }

  const safeOptions = options
    .filter(o => o && (o.label || o.text || o.value))
    .map(o => ({
      ...o,
      label: o.label || o.text || String(o.value || '').trim(),
      value: o.value || o.label || o.text || ''
    }))
    .filter(o => o.label && o.label.trim().length > 0);

  if (safeOptions.length === 0) return null;

  return (
    <div className="mt-2 flex flex-col gap-2">
      {safeOptions.map((option, index) => (
        <button
          key={index}
          onClick={() => sendMessage(option.value || option.label)}
          className="bg-gray-200 text-gray-800 px-4 py-2 rounded-xl hover:bg-gray-300 transition duration-150 ease-in-out text-sm font-medium focus:outline-none focus:ring-1 focus:ring-blue-400 shadow-sm text-left flex items-center leading-normal min-h-[36px]"
          aria-label={`Option: ${option.label}`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default OptionButtons;
